module.exports = __webpack_public_path__ + "static/img/des2.6539ee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/des2.jpg
// module id = /9hp
// module chunks = 0